export const getWatchLists = async (_, thunkAPI) => {
  try {
    const { user } = thunkAPI.extra.apiService;
    const response = await user.get(`/watchlist`);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const createWatchList = async (name, thunkAPI) => {
  try {
    const { user } = thunkAPI.extra.apiService;
    const response = await user.post(`/watchlist`, {
      name,
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteWatchList = async (id, thunkAPI) => {
  try {
    const { user } = thunkAPI.extra.apiService;
    const response = await user.delete(`/watchlist/${id}`);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const addProduct = async (data, thunkAPI) => {
  try {
    const { watchlist_id, product_id, source } = data;
    const { user } = thunkAPI.extra.apiService;

    const response = await user.post(
      `/watchlist/${watchlist_id}/product/${product_id}`,
      {
        source,
      }
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getProduct = async (payload, thunkAPI) => {
  try {
    const { user } = thunkAPI.extra.apiService;
    const { watchlist_id, source, sort } = payload;
    let url = `/watchlist/${watchlist_id}?source=${source}`;
    
    if (sort) {
      url += `&sort=${sort}`;
    }
    
    const response = await user.get(url);
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteProduct = async (data, thunkAPI) => {
  try {
    const { watchlist_id, product_id, source } = data;
    const { user } = thunkAPI.extra.apiService;

    const response = await user.delete(
      `/watchlist/${watchlist_id}/product/${product_id}`,
      {
        params: {
          source,
        },
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const renameWatchlist = async (data, thunkAPI) => {
  try {
    const { name, watchlist_id } = data;
    const { user } = thunkAPI.extra.apiService;
    const response = await user.patch(`/watchlist/${watchlist_id}`, {
      name,
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
